"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATION_DENIED = exports.SET_WAITING_FOR_LOCATION = exports.UPDATE_LOCATION_SUGGESTIONS = exports.UPDATE_LOCATION = exports.UPDATE_LOCATION_INFORMATION = void 0;
var UPDATE_LOCATION_INFORMATION = 'UPDATE_LOCATION_INFORMATION';
exports.UPDATE_LOCATION_INFORMATION = UPDATE_LOCATION_INFORMATION;
var UPDATE_LOCATION = 'UPDATE_LOCATION';
exports.UPDATE_LOCATION = UPDATE_LOCATION;
var UPDATE_LOCATION_SUGGESTIONS = 'UPDATE_LOCATION_SUGGESTIONS';
exports.UPDATE_LOCATION_SUGGESTIONS = UPDATE_LOCATION_SUGGESTIONS;
var SET_WAITING_FOR_LOCATION = 'SET_WAITING_FOR_LOCATION';
exports.SET_WAITING_FOR_LOCATION = SET_WAITING_FOR_LOCATION;
var LOCATION_DENIED = 'LOCATION_DENIED';
exports.LOCATION_DENIED = LOCATION_DENIED;
//# sourceMappingURL=actionTypes.js.map